/**
 * @param {function(): *} retryFunc - 繰り返したいPromiseを返す関数
 * @param {function(*): boolean} evalFunc - これがTrueを返すまでretryFuncをretryする
 * @param {number} delay
 * @return Promise
 */
export const retryPromise = (retryFunc, evalFunc, delay) => {
  const retry = (resolve, reject) => retryFunc()
    .then((result) => ({ result, isCompleted: evalFunc(result) }))
    .then((data) => {
      if (data.isCompleted) return resolve(data.result)
      console.log('retry...')
      setTimeout(() => retry(resolve, reject), delay)
    })
    .catch(error => {
      return reject(error)
    })
  return new Promise(retry)
}


export const fibonacciRetryPromise = (retryFunc, evalFunc) => {
  let fibonacci = [0, 1]
  let repeatCount = 1
  const retry = (resolve, reject) => retryFunc()
    .then((result) => ({ result, isCompleted: evalFunc(result) }))
    .then((data) => {
      if (data.isCompleted) return resolve(data.result)
      console.log('retry...')
      fibonacci.push(fibonacci[repeatCount - 1] + fibonacci[repeatCount])
      setTimeout(() => retry(resolve, reject), 1000 * fibonacci[repeatCount])
      repeatCount++
    })
    .catch(error => {
      return reject(error)
    })
  return new Promise(retry)
}
